import { render, staticRenderFns } from "./AddProject.modal.vue?vue&type=template&id=674d9bf6&scoped=true&"
import script from "./AddProject.modal.vue?vue&type=script&lang=js&"
export * from "./AddProject.modal.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.modal.vue?vue&type=style&index=0&id=674d9bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d9bf6",
  null
  
)

export default component.exports